// import "@babel/polyfill";
// import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/vuetify";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import VueWorker from "vue-worker";

Vue.config.productionTip = false;
// Vue.use(VueWorker);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
